import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetService = async (serviceOfferingID, pageSize, pageNumber, keyword, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {        
      const queryParams = new URLSearchParams({
        serviceOfferingID,
        pageSize,
        pageNumber,
        keyword: keyword || "", 
      }).toString();

      const response = await fetch(`${dev_baseUrl}/Service/get?${queryParams}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        }
      });
      
      const data = await response.json();                           

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {      
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.', error: error };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};
